import React from 'react'
import cls from 'classnames';

interface Props {
  name: string;
  type?: 'regular' | 'solid';
  className?: string;

  /**
   * Size in px.
   */
  size?: number;
  style?: React.CSSProperties;

  /**
   * Shether to apply an interactive style.
   */
  interactive?: boolean;
}

/**
 * Renders a single Font Awesome icon.
 * @author Johan Svensson
 */
export const FontAwesomeIcon: React.FC<Props> = ({
  name, type = 'solid', size, className, style
}) => {
  return (
    <i
      className={cls([
        cls({
          "icon": true,
          "far": type === "regular",
          "fas": type === "solid",
          [`fa-${name}`]: true
        }),
        className
      ])}
      style={{ fontSize: size, ...style }}>
    </i>
  );
};

export default FontAwesomeIcon;